<app-loader [isLoading]="loading"></app-loader>
<header>
    <span>Filter displayed data</span>
    <button type="button" (click)="dialogRef.close()">
        <span></span>
    </button>
</header>

@if(data.activeView===2){
    <div class="group">
        <label for="memName">Filter by member name</label>
        <input type="text" id="memName" class="dp-input-control" placeholder="Enter member name"
        name="address" [(ngModel)]="appliedFilters.memName">
    </div>
}

<div class="group">
    <label for="wlst">Filter by wishlist</label>
    <input type="text" id="wlst" class="dp-input-control" placeholder="Enter wishlist name" [matAutocomplete]="wslist"
    name="wishlist" [(ngModel)]="wishlistInput" (input)="filterWishlistNames()">
    <mat-autocomplete #wslist="matAutocomplete">
        @for (wishlist of filteredWishlist; track wishlist.id) {
            <mat-option [value]="wishlist.title"
            (click)="appliedFilters.wishlistId=wishlist.id">
                {{wishlist.title}}
            </mat-option>
        }
    </mat-autocomplete>
</div>

@if(data.activeView===3){
    <div class="group">
        <label for="ulst">Filter by visited user</label>
        <input type="text" id="ulst" class="dp-input-control" placeholder="Enter visited user name" [matAutocomplete]="vsUser" 
        name="user" [(ngModel)]="userNameInput" (input)="filterUserName()">
        <mat-autocomplete #vsUser="matAutocomplete">
            @for (user of filteredUserlist; track $index) {
                <mat-option [value]="user.userName"
                (click)="appliedFilters.userId=user.user_id">
                    {{user.userName}}
                </mat-option>
            }
        </mat-autocomplete>
    </div>

    <div class="group">
        <label for="fdbk">Filter by feedback</label>
        <mat-form-field class="select-mat-form-field dp-input-control select">
            <mat-select id="fdbk" placeholder="(Select feedback category)" name="feedback"
                [(ngModel)]="appliedFilters.feedbackCategoryId">
                @for (item of feedbackList; track item.feedbackCd) {
                <mat-option [value]="item.feedbackCd">
                    {{item.feedbackMsg}}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
}

<div class="group">
    <label for="address">Filter by address</label>
    <input type="text" id="address" class="dp-input-control" placeholder="Enter member address"
    name="address" [(ngModel)]="appliedFilters.address">
</div>
<button type="button" class="dp-secondary-btn" (click)="applyFilter()">Apply filter</button>